import React, { Fragment, useEffect, useState } from "react";
import Logo from "@/assets/images/Vite_White_Remove_Bg.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { staticSidebarOptions } from "@/static/static";
import IconLogout from "@/components/svg/IconLogout";
import { Button } from "@/components/ui/button";
import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { logout } from "@/store/actions/auth/login";
import { useMediaQuery } from "react-responsive";
import IconResearchNote from "@/components/svg/iconResearchNote";
import { GoStar } from "react-icons/go";
import All from "@/assets/icons/all";
import { getAllSidebarInfo } from "@/store/actions/sidebarAction";
import { Edit, Plus, Rss, Trash, Trash2 } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { deleteRssFeed } from "@/store/actions/feedsAction";
import { deleteAnnotationSpace, exitFromCurrentAnnotationSpace, getAllAnnotationSpaces } from "@/store/actions/annotationSpace";
import { HiOutlineRectangleGroup } from "react-icons/hi2";

const DashboardSidebar = (props) => {
  const {
    toggleMiniSidebar,
    setToggleMiniSidebar,
    toggleResponsiveSidebar,
    currentNode,
    setCurrentNode,
    setAllSidebarBoards,
    allSidebarBoards,
    setAllSidebarFeeds,
    setAllSidebarSpaces,
    allSidebarSpaces,
    allSidebarFeeds,
    sidebarActiveFeed,
    setSidebarActiveFeed,
    currentActiveFeedDetail,
    setCurrentActiveFeedDetail,
    currentAnnotationSpaceDetail,
    setCurrentAnnotationSpaceDetail,
  } = props;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLargeScreen = useMediaQuery({
    query: "(min-width: 992px)",
  });
  const [sidebarOptions, setSidebarOptions] = useState([]);
  const [isOpenCreateFolderModel, setIsOpenCreateFolderModel] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [closeModelData, setCloseModelData] = useState(null);
  // move to another category
  const [editFolderModelData, setEditFolderModelData] = useState(null);
  const [isOpenSpaceModel, setIsOpenSpaceModel] = useState(false);
  const [editSpaceModelData, setEditSpaceModelData] = useState(null);

  useEffect(() => {
    if (currentNode === "feeds") {
      dispatch(getAllSidebarInfo({})).then((response) => {
        if (response?.data?.success) {
          response?.data?.data?.feedCategories?.length > 0
            ? setAllSidebarFeeds(response?.data?.data?.feedCategories)
            : setAllSidebarFeeds([]);
          response?.data?.data?.boards?.length > 0
            ? setAllSidebarBoards(response?.data?.data?.boards)
            : setAllSidebarBoards([]);
        }
      });
    }
  }, [currentNode]);

  useEffect(() => {
    if (["annotation", "feeds"].includes(currentNode)) {
      dispatch(getAllAnnotationSpaces({})).then((response) => {
        if (response?.data?.success) {
          setAllSidebarSpaces(response?.data?.data)
        }
      });
    }
  }, [currentNode]);

  useEffect(() => {
    if (localStorage.getItem("activeFeed")) {
      setSidebarActiveFeed(JSON.parse(localStorage.getItem("activeFeed")));
    } else {
      setSidebarActiveFeed({
        label: "All",
        value: "all",
      });
    }
  }, []);

  useEffect(() => {
    if (sidebarActiveFeed !== null) {
      localStorage.setItem("activeFeed", JSON.stringify(sidebarActiveFeed));
    }
  }, [sidebarActiveFeed]);

  const handleLogout = () => {
    dispatch(logout(navigate));
  };

  useEffect(() => {
    localStorage.setItem("allBoards", JSON.stringify(allSidebarBoards));
  }, [allSidebarBoards]);

  useEffect(() => {
    setSidebarOptions(() => {
      const role = localStorage.getItem("role");

      if (role === "user") {
        const filteredOptions = staticSidebarOptions.filter((option) => {
          return option.nodeTitle === currentNode;
        });

        return filteredOptions;
      } else {
        const filteredOptions = staticSidebarOptions.filter((option) => {
          return option.linkRole === 'admin';
        });

        return filteredOptions;
      }
    });
  }, [currentNode]);

  const handleFeedWithCategoryClick = (feed, category) => {
    const selectedFeed = feed?.name?.toLowerCase() === "all" ? { label: "All", value: "all" } : {
      label: feed?.name,
      value: feed?._id,
      categoryName: category?.name,
      categoryId: category?._id,
    };
    setCurrentActiveFeedDetail(selectedFeed);
    feed?.name?.toLowerCase() === "all" ? navigate(`/feeds`) : navigate(`/feeds/category/${category?.name}/${feed?.name}`);
  };

  const renameFeedDetail = (data) => {
    setIsOpen(true);
    setEditData(data);
  };

  const handleDeleteFeed = (data) => {
    const { item } = data;
    dispatch(deleteRssFeed({ feedId: item?._id })).then((response) => {
      if (response?.data?.success) {
        dispatch(getAllSidebarInfo({})).then((response) => {
          if (response?.data?.success) {
            response?.data?.data?.feedCategories?.length > 0 ? setAllSidebarFeeds(response?.data?.data?.feedCategories) : setAllSidebarFeeds([]);
            response?.data?.data?.boards?.length > 0 ? setAllSidebarBoards(response?.data?.data?.boards) : setAllSidebarBoards([]);
          }
        });
      }
    });
  };

  const staticSidebarOptionsCustom = [
    {
      id: 1,
      label: "Catgeory",
      icon: (
        <All className="w-5 h-5 text-white group-[.active]:text-themeV2" />
      ),
      href: "/feeds/category",
      nodeTitle: "feeds",
      children: [],
    },
    {
      id: 2,
      label: "BookMarks",
      icon: (
        <GoStar className="w-5 h-5 text-white group-[.active]:text-themeV2" />
      ),
      href: "/feeds/bookmarks",
      nodeTitle: "feeds",
      children: [],
    },
  ];

  const handleClickCancel = () => {
    setOpenCancelDialog(false);
  };
  const handleClickContinue = () => {
    closeModelData !== null && handleDeleteFeed(closeModelData);
    setOpenCancelDialog(false);
  };

  const handleDeleteAnnotationSpace = (e, space) => {
    e.stopPropagation();
    dispatch(deleteAnnotationSpace({ deleteSpaceId: space._id })).then((response) => {
      if (response?.data?.success) {
        dispatch(getAllAnnotationSpaces({})).then((response) => {
          if (response?.data?.success) {
            setAllSidebarSpaces(response?.data?.data);
          }
        });
      }
    });
  }

  const exitFromAnnotationSpace = (e, space) => {
    e.stopPropagation();
    dispatch(exitFromCurrentAnnotationSpace({ spaceId: space._id })).then((response) => {
      if (response?.data?.success) {
        dispatch(getAllAnnotationSpaces({})).then((response) => {
          if (response?.data?.success) {
            setAllSidebarSpaces(response?.data?.data);
            navigate("/feeds")
            setCurrentActiveFeedDetail({
              label: "All",
              value: "all",
            })
          }
        });
      }
    });
  }

  const getIsActiveState = (currentNode, pathname, label) => {
    const activePath = pathname.split("/")?.filter((path) => path !== "")[1];
    const paths = pathname.split("/")?.filter((path) => path !== "");

    switch (currentNode) {
      case "feeds":
        if (paths[0] === "feeds" && !["bookmarks", "today"].includes(paths[1])) {
          return label?.toLowerCase() === "dashboard" && paths[0]?.toLowerCase() === "feeds";
        }
        return paths[1]?.toLowerCase() === label?.toLowerCase();

      case "annotation":
        if (paths?.length === 1 && paths[0] === "annotation") {
          return "Research Dashboard" === label;
        }
        return activePath?.split("-").join(" ")?.toLowerCase() === label?.toLowerCase();

      case "advanced_search":
        return activePath?.toLowerCase() === label?.toLowerCase();

      default:
        return activePath?.toLowerCase() === label?.toLowerCase();
    }
  };

  return (
    <aside
      onMouseEnter={() => setToggleMiniSidebar(false)}
      className={`fixed top-0 lg:!start-0 transition-all duration-100 group h-screen z-[8888] bg-theme
        ${toggleResponsiveSidebar ? "start-0" : "-start-full"}  
        ${toggleMiniSidebar && isLargeScreen ? "!w-[80px] sidebar-mini" : "w-[260px]"} `}
    >
      <Button
        className="w-7 h-7 p-0 rounded-full absolute top-16 -end-3.5 z-30 lg:flex hidden bg-theme/95 border border-gray-400 hover:bg-theme"
        onClick={() => setToggleMiniSidebar(!toggleMiniSidebar)}
      >
        <ChevronLeftIcon
          strokeWidth="2.2"
          className={`text-white w-5 h-5 transition-all duration-300 ${toggleMiniSidebar ? "rotate-180" : ""
            }`}
        />
      </Button>
      <div className="sidebar-header logo-part p-5 pb-0 min-h-16 lg:block hidden">
        <Link to="/" className="flex justify-center items-center">
          <div className="w-[105px] h-[30px]">
            <img
              src={Logo}
              alt="logo"
              className="transition-all w-full duration-300 group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible group-[.sidebar-mini]:w-0 opacity-100 visible h-full mx-auto"
            />
          </div>
        </Link>
      </div>

      <ScrollArea className=" h-[calc(100%-120px)]  w-full rounded-sm  p-0">
        {toggleMiniSidebar === false && currentNode === "feeds" && (
          <>
            <div className=" pt-3 px-5">
              <Button
                className="w-full  px-5  hover:bg-themeV2/15 bg-themeV2/10  py-3 text-white text-sm rounded-sm"
                onClick={() => setIsOpen(true)}
              >
                <Rss className="w-4 h-4" /> Add Feed
              </Button>
            </div>
          </>
        )}
        {toggleMiniSidebar === true && currentNode === "feeds" && (
          <div className="px-3 pt-5">
            <div className={`py-3 px-5 group-[.sidebar-mini]:px-[19px] block rounded-sm group  my-2 ${false ? "bg-themeV2/10 active" : ""}`}>
              <div className="flex items-center gap-4">
                <span>
                  <Rss className="w-5 h-5 text-white group-[.active]:text-themeV2" />
                </span>
                <h5 className="text-sm font-500 text-white  group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible transition-all duration-300">
                  Add Feed
                </h5>
              </div>
            </div>
          </div>
        )}
        <div className="menu-part px-5 group-[.sidebar-mini]:px-3 transition-all duration-300 !py-0 lg:h-[calc(100%-120px)] h-[calc(100%-40px)] overflow-y-auto overflow-x-hidden scrollbar-w-thin ">
          <ul className={`pt-3 ${isLargeScreen ? "" : "pt-16"}`}>
            {sidebarOptions?.length > 0 ? sidebarOptions.map(({ href, icon, label, children, linkRole }, index) => {
              const isActive = true;
              const isDisabledPath = ['/annotation/ai-summary'];
              return (
                <Fragment key={(Math.random() * 100)}>
                  {
                    linkRole === "user" ? <li >
                      {!children?.length > 0 ? (
                        <Link
                          to={href}
                          className={`py-3 px-5 group-[.sidebar-mini]:px-[19px] block rounded-sm group my-2 ${isActive ? "bg-themeV2/10 active" : ""}`}
                        >
                          <div className="flex items-center gap-4">
                            <span>{icon}</span>
                            <h5 className="text-sm font-500 text-white  group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible transition-all duration-300">
                              {label}
                            </h5>
                          </div>
                        </Link>
                      ) : (
                        <div className="">
                          {children?.length > 0 && (
                            <ul className=" ">
                              {children?.length > 0 ? children.map(
                                ({ href, icon, label }) => {
                                  const isActive = getIsActiveState(currentNode, pathname, label);
                                  return (
                                    <Fragment key={(Math.random() * 100)}>
                                      <Link
                                        to={isDisabledPath?.includes(href) ? null : href}
                                        className={`py-4 w-full px-5 mb-1 group-[.sidebar-mini]:px-[19px] transition-all duration-300 block rounded-sm group cursor-pointer ${isActive ? "!bg-themeV2/10 group-active active" : ""} `}
                                      >
                                        <div className="flex items-center gap-4">
                                          <span className={` text-white ${isDisabledPath?.includes(href) && !isActive ? "!text-gray-400 " : ""}`}>{icon}</span>
                                          <h5
                                            className={`text-sm font-500 group-[.active]:text-themeV2 text-white ${isDisabledPath?.includes(href) && !isActive ? "!text-gray-400 " : ""} group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible transition-all duration-300`}
                                          >
                                            {label}
                                          </h5>
                                        </div>

                                      </Link>

                                    </Fragment>
                                  );
                                }
                              ) : null}
                            </ul>
                          )}
                        </div>
                      )}
                    </li> : <li>
                      <Link
                        to={href}
                        className={`py-4 w-full px-5 mb-1 group-[.sidebar-mini]:px-[19px] transition-all duration-300 block rounded-sm group cursor-pointer ${isActive ? "!bg-themeV2/10 group-active active" : ""} ${isDisabledPath?.includes(href) && !isActive ? "!text-gray-400" : ""} `}
                      >
                        <div className="flex items-center gap-4">
                          <span className="text-white">{icon}</span>
                          <h5
                            className={`text-sm font-500 group-[.active]:text-themeV2 text-white  ${isDisabledPath?.includes(href) && !isActive ? "!text-gray-400" : ""} group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible transition-all duration-300`}
                          >
                            {label}
                          </h5>
                        </div>

                      </Link>
                    </li>
                  }
                </Fragment>
              )
            }) : null}
            {toggleMiniSidebar === true && currentNode === "feeds" && staticSidebarOptionsCustom?.length > 0 ? staticSidebarOptionsCustom?.map((item, index) => {
              return (
                <div
                  className={`py-3 px-5 group-[.sidebar-mini]:px-[19px] block rounded-sm group ${false ? "bg-themeV2/10 active" : ""
                    } my-2`}
                >
                  <div className="flex items-center gap-4">
                    <span>{item?.icon}</span>
                    <h5 className="text-sm font-500 text-white  group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible transition-all duration-300">
                      {item?.label}
                    </h5>
                  </div>
                </div>
              );
            }) : null}
            {toggleMiniSidebar === false && currentNode === "feeds" && (
              <div className="pt-2">
                <p className="text-gray-400 text-[12px] uppercase pb-2">
                  Categories
                </p>

                {[{ name: "All" }, ...allSidebarFeeds].map(
                  (category, index) => {
                    const urlPath = pathname
                      .split("/")
                      ?.filter((path) => path !== "")[3];
                    const path = decodeURIComponent(urlPath);

                    return (
                      <Fragment key={index}>
                        {category?.name?.toLowerCase() === "all" && (
                          <Link
                            to={
                              category?.name?.toLowerCase() === "all"
                                ? `/feeds`
                                : `/feeds/${category?._id}`
                            }
                            className={`py-2 px-5 group-[.sidebar-mini]:px-[19px] block rounded-sm group cursor-pointer ${category?.name?.toLowerCase() ===
                              currentActiveFeedDetail?.label?.toLowerCase()
                              ? "bg-themeV2/10 active"
                              : ""
                              }`}
                            onClick={() => handleFeedWithCategoryClick(category)}
                          >
                            <div className="flex items-center gap-4">
                              <span>
                                {category?.name?.toLowerCase() === "all" ? (
                                  <All
                                    className={`w-6 h-6 ${category?.name?.toLowerCase() ===
                                      currentActiveFeedDetail?.label?.toLowerCase()
                                      ? "!text-themeV2"
                                      : "!text-white"
                                      }`}
                                  />
                                ) : (
                                  <IconResearchNote className="w-5 h-5 text-themeV2" />
                                )}
                              </span>
                              <h5 className={`text-sm text-white transition-all duration-300 group-[.active]:text-themeV2 group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible font-semibold`} >
                                {category?.name?.toLowerCase() === "all" ? "All" : category?.name}
                              </h5>
                            </div>
                          </Link>
                        )}

                        {category?.name?.toLowerCase() !== "all" && (
                          <CollapsibleSection
                            key={category._id}
                            title={category.name}
                            isActive={
                              category?._id ===
                              currentActiveFeedDetail?.categoryId &&
                              path === currentActiveFeedDetail?.value
                            }
                            category={category}
                            setAllSidebarFeeds={setAllSidebarFeeds}
                            setAllSidebarBoards={setAllSidebarBoards}
                            setIsOpenCreateFolderModel={
                              setIsOpenCreateFolderModel
                            }
                            setEditFolderModelData={setEditFolderModelData}
                          >
                            {category?.userFeeds?.length > 0 ? category?.userFeeds?.map((item) => {

                              return (
                                <TooltipProvider key={item.name}>
                                  <Tooltip>
                                    <TooltipTrigger
                                      asChild
                                      className="!font-500"
                                    >
                                      <ContextMenu modal={false}>
                                        <ContextMenuTrigger>
                                          <div
                                            className={`flex ps-12 items-center justify-between px-4 py-2 text-gray-200 cursor-pointer !font-500 space-x-2 ${path ===
                                              currentActiveFeedDetail?.label &&
                                              currentActiveFeedDetail?.value ===
                                              item?._id ? "!text-themeV2" : ""} `}
                                            onClick={() => handleFeedWithCategoryClick(item, category)}
                                          >
                                            <div className="flex items-center text-sm !font-500">
                                              <img
                                                src={
                                                  item?.feed?.image ||
                                                  "/assets/images/placeholder-image.svg"
                                                }
                                                alt={item?.name}
                                                className="w-4 h-4 mr-2"
                                                loading="lazy"
                                              />
                                              <span className="font-inter text-[13px]">
                                                {item?.name}
                                              </span>
                                            </div>
                                            {item.unread > 0 && (
                                              <span className=" text-sm  px-2 py-1 rounded-full">
                                                {item?.unread}
                                              </span>
                                            )}
                                          </div>
                                        </ContextMenuTrigger>
                                        <ContextMenuContent className=" bg-white rounded-sm">
                                          <ContextMenuItem
                                            className="cursor-pointer space-x-2 hover:bg-gray-100"
                                            onClick={() =>
                                              renameFeedDetail({
                                                category,
                                                item,
                                              })
                                            }
                                          >
                                            <Edit className="w-4 h-4 " />
                                            <span>Edit</span>
                                          </ContextMenuItem>
                                          <ContextMenuItem
                                            className="cursor-pointer space-x-2 hover:bg-gray-100 text-rose-500"
                                            onClick={() => {
                                              setCloseModelData({
                                                category,
                                                item,
                                              });
                                              setOpenCancelDialog(true);
                                            }}
                                          >
                                            <Trash className="w-4 h-4 text-rose-500" />{" "}
                                            <span>Unfollow</span>
                                          </ContextMenuItem>
                                        </ContextMenuContent>
                                      </ContextMenu>
                                    </TooltipTrigger>
                                    <TooltipContent className="rounded-sm">
                                      <p>{item?.name}</p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              );
                            }) : null}
                          </CollapsibleSection>
                        )}
                      </Fragment>
                    );
                  }
                )}
                <div className=" pt-0">
                  <Button
                    className="w-full  px-5  bg-transparent hover:bg-themeV2/10 py-3 text-white text-sm rounded-sm space-x-0"
                    onClick={() => setIsOpenCreateFolderModel(true)}
                  >
                    {" "}
                    <Plus className="h-4 w-4" /> <span>Create New Category</span>
                  </Button>
                </div>
              </div>
            )}

            {toggleMiniSidebar === false && ["annotation", "feeds"].includes(currentNode) && (
              <div className="pt-2 px-2 space-y-1 mt-2">
                <p className="text-gray-400 text-[12px] uppercase pb-2">
                  Spaces
                </p>

                {allSidebarSpaces?.length > 0 ? allSidebarSpaces.map((space, index) => {
                  const urlPath = pathname.split("/")?.filter((path) => path !== "")[2];
                  const path = decodeURIComponent(urlPath);

                  return (
                    <div key={index} className="">
                      {space?.name?.toLowerCase() !== "all" && (
                        <ContextMenu modal={false}>
                          <ContextMenuTrigger>
                            <button
                              onClick={() => {
                                currentNode === "feeds" ? navigate(`/feeds/spaces/${space?.name}`) : navigate(`/annotation/spaces/${space?.name}`);
                                currentNode === "feeds" ? setCurrentNode("feeds") : setCurrentNode("annotation");
                                setCurrentAnnotationSpaceDetail(space);
                              }}
                              className={`w-full flex items-center px-4 py-2 space-x-2 hover:bg-themeV2/10 rounded-sm text-sm  text-white  ${space?._id === currentAnnotationSpaceDetail?._id && path === currentAnnotationSpaceDetail?.name ? "!text-themeV2 !bg-themeV2/20" : ""}  `}
                            >
                              <HiOutlineRectangleGroup className="h-5 w-5" />
                              <span className='font-semibold'>{space?.name}</span>
                            </button>
                          </ContextMenuTrigger>
                          <ContextMenuContent className=" bg-white rounded-sm">
                            {space?.userRole === "owner" ?
                              <>
                                <ContextMenuItem className="cursor-pointer space-x-2 " onClick={() => { setIsOpenSpaceModel(true); setEditSpaceModelData(space) }}><Edit className='w-4 h-4 ' /> <span>Edit</span></ContextMenuItem>
                                <ContextMenuItem className="cursor-pointer space-x-2 hover:bg-gray-100 text-rose-500" onClick={(e) => {
                                  handleDeleteAnnotationSpace(e, space)
                                }}><Trash2 className='w-4 h-4 ' /> <span>Delete</span></ContextMenuItem>
                              </>
                              : space?.userRole === "admin" ? <>
                                <ContextMenuItem className="cursor-pointer space-x-2 " onClick={() => { setIsOpenSpaceModel(true); setEditSpaceModelData(space) }}><Edit className='w-4 h-4 ' /> <span>Edit</span></ContextMenuItem>
                                <ContextMenuItem className="cursor-pointer space-x-2 hover:bg-gray-100 text-rose-500" onClick={(e) => {
                                  exitFromAnnotationSpace(e, space)
                                }}><Trash2 className='w-4 h-4 ' /> <span>Exit From Space</span></ContextMenuItem>
                              </> : <ContextMenuItem className="cursor-pointer space-x-2 hover:bg-gray-100 text-rose-500" onClick={(e) => {
                                exitFromAnnotationSpace(e, space)
                              }}><Trash2 className='w-4 h-4 ' /> <span>Exit From Space</span></ContextMenuItem>
                            }
                          </ContextMenuContent>
                        </ContextMenu>
                      )}
                    </div>
                  );
                }) : null}

                <div className=" py-1">
                  <Button
                    className="w-full  px-5  bg-transparent hover:bg-themeV2/20 py-3 text-white text-sm rounded-sm space-x-0"
                    onClick={() => setIsOpenSpaceModel(true)}
                  >
                    {" "}
                    <Plus className="h-4 w-4" />
                    <span> Create New Space</span>
                  </Button>
                </div>
              </div>
            )}
            {toggleMiniSidebar === true && ["annotation", "feeds"].includes(currentNode) && (
              <div className="pt-2 px-2 space-y-1 mt-2">
                {allSidebarSpaces?.length > 0 ? allSidebarSpaces.map((space, index) => {
                  const urlPath = pathname.split("/")?.filter((path) => path !== "")[2];
                  const path = decodeURIComponent(urlPath);

                  return (
                    <div key={index} className="">
                      {space?.name?.toLowerCase() !== "all" && (
                        <button

                          className={`w-fit flex items-center px-4 py-2 space-x-2 hover:bg-themeV2/10 rounded-sm text-sm  text-white  ${space?._id === currentAnnotationSpaceDetail?._id && path === currentAnnotationSpaceDetail?.name ? "!text-themeV2 !bg-themeV2/20" : ""}  `}
                        >
                          <HiOutlineRectangleGroup className="h-5 w-5" />
                        </button>
                      )}
                    </div>
                  );
                }) : null}
              </div>
            )}
          </ul>
        </div>
      </ScrollArea>
      <div className="logout-part px-5 group-[.sidebar-mini]:px-3 transition-all duration-300 pt-3">
        <div className="px-5 group-[.sidebar-mini]:px-[19px] block rounded-sm group cursor-pointer">
          <div className="flex items-center gap-4" onClick={handleLogout}>
            <span>
              <IconLogout className="text-white w-5 h-5" />
            </span>
            <h5 className="text-sm font-500 text-white group-[.sidebar-mini]:opacity-0 group-[.sidebar-mini]:invisible opacity-100 visible transition-all duration-300">
              Logout
            </h5>
          </div>
        </div>
      </div>
 
    </aside>
  );
};

export default DashboardSidebar;
